import { NgModule } from '@angular/core'
import { UnityWebglComponent } from '@components/unity-webgl/unity-webgl.component'

@NgModule({
  declarations: [UnityWebglComponent],
  exports: [UnityWebglComponent],
  imports: [],
})
export class UnityWebglModule {}
